import {
    GET_CURRENT_USER,
    GET_CURRENT_USER_BY_TIME_INTERVAL,
    SET_CURRENT_USER,
} from "./UserType"

const getCurrentUser = () => {
    return {
      type: GET_CURRENT_USER,
    }
}
const setCurrentUser = (value: any) => {
    return {
      type: SET_CURRENT_USER,
      value
    }
}

const getCurrentUserByTimeInterval = () => {
    return {
      type: GET_CURRENT_USER_BY_TIME_INTERVAL,
    }
}


export {
    getCurrentUser,
    setCurrentUser,
    getCurrentUserByTimeInterval
}
